export default __webpack_public_path__ + "static/ProValue_3@992-acd3bb90594014809a0091c859755824.png";